import { useState } from "react";

const quickLinks = ["Home", "About Us", "Services", "Category", "Vision", "Contact Us"];

const categories = ["Marathi Bhajans", "Hindi Bhajans", "Kannada Songs", "Aarti", "Live Events"];

const socialLinks = [
  {
    name: "Facebook",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
      </svg>
    ),
  },
  {
    name: "Twitter",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2" />
        <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="2" />
        <circle cx="17.5" cy="6.5" r="1.5" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z" />
        <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#1a1a1a" />
      </svg>
    ),
  },
  {
    name: "WhatsApp",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
        <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2.546 21l3.93-.919A9.93 9.93 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2z" fill="none" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.51 12 19.79 19.79 0 01.46 3.38 2 2 0 012.44 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 9.91a16 16 0 006.06 6.06l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" fill="none" stroke="currentColor" strokeWidth="2" />
    <polyline points="22,6 12,13 2,6" fill="none" stroke="currentColor" strokeWidth="2" />
  </svg>
);

const MapPinIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="10" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export default function Footer() {
  const [hoveredLink, setHoveredLink] = useState(null);
  const [hoveredSocial, setHoveredSocial] = useState(null);

  return (
    <footer className="footer">
      <div className="top-accent" />

      <div className="footer-container">
        {/* Main grid */}
        <div className="footer-grid">

          {/* ── Col 1: Brand ── */}
          <div className="brand-col">
            <div className="logo-wrap">
              <div className="logo-icon">
                <span className="logo-emoji">🎵</span>
              </div>
              <div>
                <div className="logo-name">संगीत विद्यालय शिवाजी</div>
                <div className="logo-tagline">Spiritual Music Journey</div>
              </div>
            </div>

            <p className="brand-desc">
              आपल्या आध्यात्मिक संगीत प्रवासाची सुरुवात येथून करा। मराठी,
              हिंदी आणि कन्नड भजन, आरती आणि भक्तिगीतांचा अनमोल संग्रह।
            </p>

            <div className="social-row">
              {socialLinks.map((s) => (
                <button
                  key={s.name}
                  title={s.name}
                  className={`social-btn ${hoveredSocial === s.name ? "social-btn--hovered" : ""}`}
                  onMouseEnter={() => setHoveredSocial(s.name)}
                  onMouseLeave={() => setHoveredSocial(null)}
                >
                  {s.icon}
                </button>
              ))}
            </div>
          </div>

          {/* ── Col 2: Quick Links ── */}
          <div className="link-col">
            <h4 className="col-heading">Quick Links</h4>
            <div className="col-divider" />
            <ul className="link-list">
              {quickLinks.map((link) => (
                <li key={link}>
                  <a
                    href="#"
                    className={`nav-link ${hoveredLink === link ? "nav-link--hovered" : ""}`}
                    onMouseEnter={() => setHoveredLink(link)}
                    onMouseLeave={() => setHoveredLink(null)}
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 3: Categories ── */}
          <div className="link-col">
            <h4 className="col-heading">Categories</h4>
            <div className="col-divider" />
            <ul className="link-list">
              {categories.map((cat) => (
                <li key={cat}>
                  <a
                    href="#"
                    className={`nav-link ${hoveredLink === cat ? "nav-link--hovered" : ""}`}
                    onMouseEnter={() => setHoveredLink(cat)}
                    onMouseLeave={() => setHoveredLink(null)}
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 4: Contact ── */}
          <div className="contact-col">
            <h4 className="col-heading">Contact Us</h4>
            <div className="col-divider" />
            <div className="contact-list">
              <div className="contact-item">
                <div className="contact-icon-wrap"><PhoneIcon /></div>
                <div>
                  <div className="contact-primary">मो. 7972970108</div>
                  <div className="contact-secondary">Mon – Sat, 9AM – 6PM</div>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon-wrap"><MailIcon /></div>
                <div>
                  <div className="contact-primary">info@sangeetvidyalay.com</div>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon-wrap contact-icon-wrap--top"><MapPinIcon /></div>
                <div>
                  <div className="contact-primary">संगीत विद्यालय शिवाजी यूनिट,</div>
                  <div className="contact-secondary">फग्गन सिंह चौक, शिवाजी,</div>
                  <div className="contact-secondary">राम जी बाजार</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="bottom-divider" />

        {/* Bottom bar */}
        <div className="bottom-bar">
          <span className="copyright">
            © 2024 संगीत विद्यालय शिवाजी. All rights reserved.
          </span>
          <div className="legal-links">
            {["Privacy Policy", "Terms of Service"].map((item) => (
              <a
                key={item}
                href="#"
                className={`legal-link ${hoveredLink === item ? "legal-link--hovered" : ""}`}
                onMouseEnter={() => setHoveredLink(item)}
                onMouseLeave={() => setHoveredLink(null)}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&family=Noto+Sans+Devanagari:wght@400;500;700&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        a { text-decoration: none; }

        /* ── Footer ── */
        .footer {
          background: linear-gradient(180deg, #1a1010 0%, #141010 100%);
          position: relative;
          font-family: 'Noto Sans Devanagari', sans-serif;
          overflow: hidden;
        }

        .top-accent {
          height: 3px;
          background: linear-gradient(90deg, transparent, #c0392b 20%, #d4a857 50%, #c0392b 80%, transparent);
        }

        /* ── Container ── */
        .footer-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 56px 48px 32px;
        }

        /* ── Grid: 4-column desktop ── */
        .footer-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.6fr;
          gap: 48px;
          align-items: flex-start;
        }

        /* ── Brand ── */
        .brand-col {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .logo-wrap {
          display: flex;
          align-items: center;
          gap: 14px;
        }
        .logo-icon {
          width: 52px; height: 52px;
          border-radius: 50%;
          background: linear-gradient(135deg, #c0392b, #922b21);
          border: 2px solid #d4a857;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 4px 16px rgba(192,57,43,0.35);
        }
        .logo-emoji { font-size: 22px; }
        .logo-name {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 16px;
          font-weight: 700;
          color: #d4a857;
          line-height: 1.3;
        }
        .logo-tagline {
          font-family: 'Cinzel', serif;
          font-size: 10px;
          color: rgba(212,168,87,0.7);
          letter-spacing: 1.5px;
          text-transform: uppercase;
        }
        .brand-desc {
          font-size: 13px;
          color: rgba(255,255,255,0.55);
          line-height: 1.85;
          max-width: 340px;
        }

        /* ── Social ── */
        .social-row {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        .social-btn {
          width: 40px; height: 40px;
          border-radius: 10px;
          border: 1px solid rgba(255,255,255,0.1);
          background: rgba(255,255,255,0.06);
          color: rgba(255,255,255,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.25s ease;
          transform: translateY(0);
        }
        .social-btn--hovered {
          background: rgba(212,168,87,0.18);
          border-color: rgba(212,168,87,0.5);
          color: #d4a857;
          transform: translateY(-3px);
        }

        /* ── Link columns ── */
        .link-col {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .col-heading {
          font-family: 'Cinzel', serif;
          font-size: 15px;
          font-weight: 700;
          color: #ffffff;
          letter-spacing: 0.5px;
        }
        .col-divider {
          height: 2px;
          width: 36px;
          background: linear-gradient(90deg, #d4a857, transparent);
          border-radius: 1px;
          margin-top: -8px;
        }
        .link-list {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .nav-link {
          font-family: 'Cinzel', serif;
          font-size: 13px;
          letter-spacing: 0.3px;
          color: rgba(255,255,255,0.65);
          display: block;
          transition: color 0.2s ease, padding-left 0.2s ease;
          padding-left: 0;
        }
        .nav-link--hovered {
          color: #d4a857;
          padding-left: 8px;
        }

        /* ── Contact ── */
        .contact-col {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .contact-list {
          display: flex;
          flex-direction: column;
          gap: 18px;
        }
        .contact-item {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .contact-icon-wrap {
          width: 32px; height: 32px;
          border-radius: 8px;
          background: rgba(212,168,87,0.12);
          border: 1px solid rgba(212,168,87,0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #d4a857;
          flex-shrink: 0;
        }
        .contact-icon-wrap--top {
          align-self: flex-start;
          margin-top: 2px;
        }
        .contact-primary {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 13px;
          color: rgba(255,255,255,0.8);
          font-weight: 500;
          line-height: 1.5;
        }
        .contact-secondary {
          font-family: sans-serif;
          font-size: 11px;
          color: rgba(255,255,255,0.4);
          line-height: 1.5;
        }

        /* ── Bottom bar ── */
        .bottom-divider {
          height: 1px;
          background: linear-gradient(90deg,
            transparent,
            rgba(255,255,255,0.1) 20%,
            rgba(255,255,255,0.1) 80%,
            transparent);
          margin: 40px 0 24px;
        }
        .bottom-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 12px;
        }
        .copyright {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 12px;
          color: rgba(255,255,255,0.35);
        }
        .legal-links {
          display: flex;
          gap: 24px;
        }
        .legal-link {
          font-family: 'Cinzel', serif;
          font-size: 12px;
          letter-spacing: 0.3px;
          color: rgba(255,255,255,0.45);
          transition: color 0.2s ease;
        }
        .legal-link--hovered { color: #d4a857; }

        /* ════════════════════════════════════
           RESPONSIVE BREAKPOINTS
        ════════════════════════════════════ */

        /* ── Large tablet: 900px – 1100px ── */
        @media (max-width: 1100px) {
          .footer-container {
            padding: 48px 32px 28px;
          }
          .footer-grid {
            grid-template-columns: 1.8fr 1fr 1fr 1.5fr;
            gap: 32px;
          }
        }

        /* ── Tablet: 768px – 900px — 2×2 ── */
        @media (max-width: 900px) {
          .footer-container {
            padding: 44px 28px 28px;
          }
          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 36px 28px;
          }
          .brand-col {
            grid-column: 1 / -1; /* full width on top */
          }
          .brand-desc {
            max-width: 100%;
          }
        }

        /* ── Mobile: up to 600px — stacked ── */
        @media (max-width: 600px) {
          .footer-container {
            padding: 36px 20px 24px;
          }
          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 28px 20px;
          }
          .brand-col {
            grid-column: 1 / -1;
          }
          .contact-col {
            grid-column: 1 / -1;
          }
          .logo-name { font-size: 14px; }
          .col-heading { font-size: 13px; }
          .nav-link { font-size: 12px; }
          .contact-primary { font-size: 12px; }
          .bottom-bar {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }
          .legal-links { gap: 16px; }
        }

        /* ── Small mobile: up to 420px — single column ── */
        @media (max-width: 420px) {
          .footer-container {
            padding: 32px 16px 20px;
          }
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 28px;
          }
          .brand-col,
          .contact-col {
            grid-column: auto;
          }
          .social-row { gap: 8px; }
          .social-btn { width: 36px; height: 36px; }
          .legal-links {
            flex-direction: column;
            gap: 8px;
          }
        }
      `}</style>
    </footer>
  );
}